export const userState={
    signedIn:false,
    uname:'',
    upin:'',
    country:'',
    uAddess:'',
    uemail:'',
    password:'',
}